import { inject, observer } from 'mobx-react';
import withRouter from '@/components/withRouter';
import styles from './styles/RoleIntroduce.module.scss';

import defaultAvatar from '@/assets/images/simulation/default_avatar.png';
import { Storage } from '@/utils/Storage';
import { useEffect } from 'react';
import EnterImg from '@/components/CaseProgressCircle/EnterImg';
const RoleIntroduce = (props) => {
    let { navigate } = props;
    let { simulation } = props.store;
    let { character = { other_roles: [] }, goal, rules, setHeaderIcon, verifyLogin, getPath } = simulation;
    // 模拟数据 - 从设计图中提取

    const onclickArrow = async () => {
        let res = await verifyLogin();
        if (!res) {
            return;
        }
        let path = getPath();
        navigate(`${path}/event`, { replace: true });
    };
    useEffect(() => {
        setHeaderIcon({
            role: false,
            back: true,
            reStart: false
        });
        let backGuide = Storage.get(simulation.backStorageName);
        if (!backGuide) {
            simulation.setGuideModal('back');
        }
    }, []);
    return (
        <div className={styles.container}>
            {/* 角色信息区域 */}
            <div className={styles.roleInfoSection}>
                <div className={styles.avatarContainer}>
                    <div className={styles.avatar}>
                        {/* 实际项目中替换为真实头像 */}
                        <img src={character.avatar || defaultAvatar} alt={character.name} />
                    </div>
                    <div className={styles.roleName}>
                        <span className={styles.roleLabel}>【你】：{character?.name}</span>
                        <span className={styles.roleText}>{character?.role}</span>
                    </div>
                </div>
            </div>
            <div className={styles.mainContent}>
                {/* 角色卡片区域 */}

                <div className={[`${styles.roleCardsContainer} ${styles.groupWrap}`]}>
                    <div className={styles.roleCardsTitle}>【其他角色】</div>
                    {character?.other_roles &&
                        character?.other_roles.map((role, index) => (
                            <div key={index} className={styles.roleCard}>
                                <div className={styles.roleCardName}>{role.name}</div>
                                <div className={styles.roleCardDescription}>{role.intro}</div>
                            </div>
                        ))}
                </div>

                {/* 目标区域 */}
                <div className={[`${styles.section} ${styles.groupWrap}`]}>
                    <div className={styles.sectionTitle}>【你的目标】</div>
                    <div className={styles.sectionContent}>{goal?.description}</div>
                </div>
                {/* 行为约束规则区域 */}
                <div className={[`${styles.section} ${styles.groupWrap}`]}>
                    <div className={styles.sectionTitle}>【行为约束规则】</div>
                    {rules.map((rule, index) => (
                        <div key={index} className={[`${styles.sectionContent} ${styles.ruleItem}`]}>
                            {rule}
                            {/* <span className={styles.ruleDot}></span>
                            <span className={styles.ruleText}> {rule}</span> */}
                        </div>
                    ))}
                </div>
            </div>

            <div onClick={onclickArrow} className={styles.arrowContainer}>
                {/* <Arrow></Arrow> */}
                <EnterImg></EnterImg>
            </div>
        </div>
    );
};

export default withRouter(inject('store')(observer(RoleIntroduce)));
